import { AppBar, Toolbar } from "@mui/material";
import logo from "assets/logo/Sage2.0-logo.png";
import React from "react";

const MobileLayoutHeader = () => {
  return (
    <AppBar sx={{ backgroundColor: "white" }}>
      <Toolbar>
        <img src={logo} width={100} height={30} />
      </Toolbar>
    </AppBar>
  );
};

export default MobileLayoutHeader;
